import React, {useState} from "react";

const UploadCodeInfoBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = (val = false) => {
        setIsOpen(val);
    };

    return (
        <div className='infoBar'>
            <button
                type='button'
                className='btnOpen'
                onClick={() => toggle(!isOpen)}
            >
                ?
            </button>
            {isOpen && (
                <div className='upload-code-list'>
                    <div className='upload-code-tooltip'>
                        <p>Открывает доступ к загрузке Исходного Кода в выбранный репозиторий</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UploadCodeInfoBar;

